import { cn } from '@/lib/utils'

export function Spin({
  spinning,
  className,
  children,
}: {
  spinning: boolean
  className?: string
  children: React.ReactNode
}) {
  return (
    <>
      {spinning && (
        <div className="absolute inset-0 flex justify-center items-center z-10">
          <div
            className={cn(
              'animate-spin rounded-full border-4 border-gray-300 border-t-primary w-6 h-6',
              className,
            )}
          />
        </div>
      )}
      {spinning ? (
        <div className="opacity-50">{children}</div>
      ) : (
        <>{children}</>
      )}
    </>
  )
}
